/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetContactsResponseDataFromJSON, GetContactsResponseDataToJSON } from './GetContactsResponseData';
export function GetContactsResponseFromJSON(json) {
    return GetContactsResponseFromJSONTyped(json, false);
}
export function GetContactsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetContactsResponseDataFromJSON(json['data'])
    };
}
export function GetContactsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetContactsResponseDataToJSON(value.data)
    };
}
